import { IconType } from "react-icons";
import {
  GiFamilyHouse,
  GiMusicalNotes,
  GiChickenOven,
  GiTowerBridge,
} from "react-icons/gi";
import { MdOutlineTram } from "react-icons/md";

import { PiCouchFill } from "react-icons/pi";

interface Icon {
  id: string;
  component: IconType;
}

export const icons: Icon[] = [
  {
    // 住まい
    id: "9h7hf5-8j",
    component: GiFamilyHouse,
  },
  {
    // 娯楽
    id: "ylxuj7bb1lt",
    component: GiMusicalNotes,
  },
  {
    // 観光
    id: "3irhjjg5vlf",
    component: GiTowerBridge,
  },
  {
    // 食事
    id: "3_pevmrwbw",
    component: GiChickenOven,
  },
  {
    // 生活
    id: "y_d_yevoo",
    component: PiCouchFill,
  },
  {
    // 交通
    id: "zlmz0ket9ii",
    component: MdOutlineTram,
  },
];
